import type { ReactElement } from 'react';

/**
 * Shared rich-text element mappings for react-i18next <Trans /> usage.
 * Extend this object as more reusable tags are introduced in translations.
 */
export const commonTransComponents = {
  bold: <b />,
} satisfies Record<string, ReactElement>;
